// extracted by mini-css-extract-plugin
export default {"flexBoxBlk":"AdminLinks_flexBoxBlk__etC2I"};